import React, { useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../components/layout/layout";
import MyPersonalizedTour from "../components/personalized-tour/my-tour-personalized";

const MyPersonalizedTourPage = () => {
  return (
    <>
      <Layout>
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-8 theiaStickySidebar">
                <div className="row justify-content-center">
                  <MyPersonalizedTour />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default MyPersonalizedTourPage;
